import { Action } from '@ngrx/store';

export enum NotesPanelActionTypes {
  CLOSE_NOTES_PANEL = 'Close notes panel'
}

export class CloseNotesPanelAction implements Action {
  readonly type = NotesPanelActionTypes.CLOSE_NOTES_PANEL;
  constructor() { }
}
